export default {
  path: '/wapErp',
  component: () => import('@/page/WapErp/wap'),
  children: [
    {
      path: 'login',
      name: 'WapERPLogin',
      component: () => import('@/page/WapErp/login')
    },
    {
      path: 'nav',
      name: 'WapERPNav',
      component: () => import('@/page/WapErp/nav')
    },
    {
      path: 'manage',
      name: 'WapERPManage',
      component: () => import('@/page/WapErp/manage')
    },
    {
      path: 'view',
      name: 'WapERPView',
      component: () => import('@/page/WapErp/view')
    },
    {
      path: 'warning',
      name: 'WapERPWarning',
      component: () => import('@/page/WapErp/warning')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/wapErp.js